export const handleErrorStatus =
  ({ setResult, setIsLoading, setShowCloseButton }): (() => void) =>
  () => {
    setResult({ success: false, error: true })
    setIsLoading(false)
    setShowCloseButton(true)
  }
